import * as React from 'react';
import Button from '@mui/material/Button';
import { Box, DialogContentText, Stack } from '@mui/material';
import GenericModal from 'components/GenericModal';

const AlertDialogSlide = ({ open, handleClose, handleOk, title, content }) => {
    const AlertDialogContent = () => (
        <Box sx={{ p: 3, width: 'min(600px, calc(100vw - 32px))' }}>
            <DialogContentText
                id="alert-dialog-slide-description"
                sx={{
                    mb: 3,
                    color: '#4b587c',
                    fontSize: '0.95rem',
                    lineHeight: 1.6,
                    whiteSpace: 'normal',
                }}>
                {content}
            </DialogContentText>
            <Stack direction="row" justifyContent="flex-end" spacing={1}>
                {handleOk && <Button onClick={handleOk}>Ok</Button>}
                <Button onClick={handleClose}>Cancel</Button>
            </Stack>
        </Box>
    );

    return (
        <div>
            <GenericModal
                open={open}
                onClose={handleClose}
                title={title}
                Component={AlertDialogContent}
                closeOnBackdrop={true}
                closeOnEsc={true}
            />
        </div>
    );
}

export default AlertDialogSlide;
